/**
 * PSIFY IMMERSIVE — prima pagină v2 (07.10.2026), după macheta mockups/home-clip-carduri (versiunea 71).
 * Compilat la public/js/immersive-home.min.js și încărcat DOAR de home/immersive.blade.php, după scriptul principal
 * (immersive.min.js), care ține mai departe Lenis, aparițiile, galeria psihologilor, meniul și pornirea particulelor.
 * Fără GSAP sau altă bibliotecă. Ce face, în ordinea machetei (src/page.js, src/serviciu.js, src/voci3d.js):
 *  1. filmul din primul ecran: două bucăți, «intro» (ea întoarce laptopul spre noi, o dată) și «bucla» (calmă, se reia);
 *     treapta după lățimea casetei, sursele puse abia când caseta se apropie (300 px), pornește când se vede destul din ea,
 *     stă când iese din ecran; la final (sau fără film) poza de dedesubt devine ultimul cadru și apare butonul de pe film;
 *  2. particulele: furtună în primul ecran; pe manifest se liniștesc și dispar, după cât a urcat secțiunea în fereastră, și
 *     nu se mai întorc (owner, 06.10: „nu mai avem nevoie să se unească în cerc”). Motorul (immersive-webgl) nu e atins;
 *  3. manifestul: cuvintele frazei mari se aprind unul câte unul când fraza ajunge în fereastră; alineatele apar lin;
 *  4. meniul își ia fondul de la primii pixeli de derulare (pe site îl ia după 80 px): titlul mare ar trece peste siglă;
 *  5. recenziile citite cu voce, într-o stivă în adâncime, după „Personal Perspectives” de pe amaterasu.ai (owner, 06.10:
 *     „Asigură-te că avem aceeași experiență! cap-coadă!”): povestea citită în față; următoarea în spate-dreapta; a treia
 *     sus în fund; cea terminată vine spre privitor și se stinge (1,5 s). Când scena intră în fereastră, după 1 s pornește
 *     vocea; cuvintele (la 40 %) se aprind fiecare la secunda la care e spus; când vocea termină (citatul, pauza și
 *     comentariul Psify sunt în același fișier) trece singură la următoarea; un clic pe scenă trece mai devreme. Mouse-ul
 *     înclină stiva (±10°); la derulare textul urcă mai repede decât pagina, iar vocea se aude plin doar cu scena în mijloc.
 *     Sunetul (public/media/home/voci) se cere abia când secțiunea ajunge la 60 % de fereastră și pornește doar după un
 *     clic sau o atingere (regula browserelor): până atunci recenziile merg fără sunet, iar butonul „Pornește sunetul” sau un
 *     clic pe scenă pornește vocea și reia recenzia. Fără script: recenziile stau una sub alta, întregi (_home.scss).
 * Pentru verificări (tests/psify/browser/home_verifica_*.cjs): window.PsihParticule, window.PsihVoci3d.
 */
(function () {
  var page = document.querySelector('.psi-page');
  if (!page) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phoneMq = window.matchMedia('(max-width: 899px)');
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ================================================================
     1. filmul din primul ecran (src/page.js)
     ================================================================ */
  (function film() {
    var split = document.getElementById('psih-pasi');
    if (!split) return;
    var media = split.querySelector('.psih-media');
    var intro = split.querySelector('.psih-clip--intro');
    var bucla = split.querySelector('.psih-clip--bucla');
    var clips = [intro, bucla].filter(Boolean);
    var conn = navigator.connection;
    var inView = false;        // caseta e în ecran
    var hasSources = false;
    var introDone = !intro;    // intro s-a terminat (sau nu există): de aici rulează bucla
    var filmOff = false;       // redarea a fost refuzată (de ex. economisirea bateriei pe iPhone): rămâne poza
    var introPrag = Math.min(1, Math.max(0.25, parseFloat(media && media.dataset.introPrag) || 0.25));
    var vazutBine = false;     // caseta s-a văzut măcar o dată cât cere pragul

    // În casetă stau două cadre: cel de sfârșit (imaginea paginii, cu amândouă în el) dedesubt și cel de început (laptopul
    // întors spre ea) deasupra, cât rulează intro. Când filmul a ajuns în repaus, sau când nu e film (mișcare redusă,
    // economisire de date, redare refuzată), caseta primește is-final: stilurile ascund cadrul de început și arată butonul.
    function posterSfarsit() {
      if (media) media.classList.add('is-final');
    }
    function activ() { return introDone ? bucla : intro; }
    function sync() {
      if (!clips.length || !hasSources || filmOff) return;
      var should = inView && !document.hidden && (introDone || vazutBine);
      var v = activ();
      clips.forEach(function (c) { if (c !== v && !c.paused) c.pause(); });
      if (!v) return;
      if (should) {
        if (v.paused) {
          v.muted = true;
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function (err) {
            // redare refuzată de browser: fără film, cu poza de sfârșit (nu „abort”, care vine când noi îl oprim)
            if (err && err.name === 'NotAllowedError') { filmOff = true; posterSfarsit(); }
          });
        }
      } else if (!v.paused) {
        v.pause();
      }
    }
    function sfarsitIntro() {
      if (introDone) return;
      introDone = true;
      sync();
    }

    if (clips.length && !reduced && !(conn && conn.saveData) && 'IntersectionObserver' in window) {
      /* treapta: prima cu lățimea ≥ 95 % din pixelii fizici ai casetei (filmul stă pe loc, fără mărire); pe telefon 75 %;
         pe 2g/3g, cea mai mică */
      var pickTier = function (v, kind) {
        var trepte;
        try { trepte = JSON.parse(v.dataset[kind + 'Trepte'] || '[]'); } catch (e) { return null; }
        if (!trepte.length) return null;
        if (conn && /^[23]g$/.test(conn.effectiveType || '')) return trepte[0];
        var lat = media.getBoundingClientRect().width || 0;
        var need = lat * (window.devicePixelRatio || 1) * (phoneMq.matches ? 0.75 : 0.95);
        for (var i = 0; i < trepte.length; i++) if (trepte[i].w >= need) return trepte[i];
        return trepte[trepte.length - 1];
      };
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          near.disconnect();
          var kind = phoneMq.matches ? 'phone' : 'desk';
          clips.forEach(function (v) {
            var tier = pickTier(v, kind);
            if (!tier) return;
            var last = null;
            ['webm', 'mp4'].forEach(function (f) {
              var s = document.createElement('source');
              s.src = tier[f];
              s.type = 'video/' + f;
              v.appendChild(s);
              last = s;
            });
            // nicio sursă nu merge: intro se sare (rulează bucla), iar fără buclă rămâne poza de sfârșit
            if (last) last.addEventListener('error', function () { if (v === intro) sfarsitIntro(); else { filmOff = true; posterSfarsit(); } });
            v.preload = 'auto';
            v.load();
            hasSources = true;
          });
          sync();
        });
      }, { rootMargin: '300px 0px' });
      // filmul rulează cât se vede măcar un sfert din casetă; intro pornește prima oară abia când se vede destul din ea
      // (data-intro-prag pe casetă: pe ecrane joase întoarcerea laptopului s-ar petrece sub marginea ecranului)
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting && e.intersectionRatio >= 0.24;
          if (e.intersectionRatio >= introPrag - 0.01) vazutBine = true;
        });
        sync();
      }, { threshold: introPrag > 0.25 ? [0.25, introPrag] : 0.25 });
      clips.forEach(function (v) { v.addEventListener('playing', function () { v.classList.add('is-on'); }); });
      if (intro) intro.addEventListener('ended', sfarsitIntro);
      // odată ce bucla se vede, poza de dedesubt devine ultimul cadru (dacă filmul e scos din memorie, nu se întoarce la început)
      if (bucla && intro) bucla.addEventListener('playing', posterSfarsit);
      near.observe(media);
      seen.observe(media);
      /* la întoarcerea în tab, pe iPhone, filmul se desena mărit până la o nouă așezare (pagina de serviciu, 02.10.2026) */
      var revenire = function () {
        if (!document.hidden) {
          clips.forEach(function (v) {
            v.style.display = 'none';
            void v.offsetHeight;
            v.style.display = '';
            v.style.objectFit = 'contain';
            void v.offsetHeight;
            v.style.objectFit = '';
          });
        }
        sync();
      };
      document.addEventListener('visibilitychange', revenire);
      window.addEventListener('pageshow', function (e) { if (e.persisted) revenire(); });
    } else if (clips.length) {
      posterSfarsit();
    }
  })();

  /* ================================================================
     2–4. particulele, manifestul, meniul (src/serviciu.js)
     ================================================================ */
  (function pagina() {
    var cont = document.getElementById('psi-webgl');
    var viziune = document.querySelector('.psih-v');
    var nav = document.querySelector('.psi-nav');
    var particule = false, ultimP = -1, ultimDim = -1;
    // ce a primit motorul ultima oară (pentru verificări)
    var stare = { p: 0, dim: 1, k: 0 };
    window.PsihParticule = { stare: stare };

    // motorul particulelor e încărcat și pornit de scriptul principal (main.js, la psify:webgl-ready, doar pe profilul
    // „full”); de aici încolo doar îi spunem cât s-a liniștit. Pe „lite” și „static” nu e canvas: fondul static al site-ului.
    function porneste() {
      if (particule || !cont || !window.PsifyWebGL || page.dataset.psiProfile !== 'full') return;
      if (!cont.querySelector('canvas')) return;
      particule = true;
      page.classList.add('psih-particule');
    }

    var navDerulat = null;
    function cadru() {
      window.requestAnimationFrame(cadru);
      var vh = window.innerHeight, y = window.scrollY;
      // 4. meniul își ia fondul de la primii pixeli de derulare (_home.scss)
      if (nav && (y > 4) !== navDerulat) { navDerulat = y > 4; nav.classList.toggle('psih-derulat', navDerulat); }
      if (!particule) { porneste(); if (!particule) return; }

      // 2. cât a urcat manifestul în fereastră: 0 cât marginea lui de sus e sub 80 % din fereastră (sau unde era la
      //    încărcare, dacă era deja mai sus: pe telefoanele înalte), 1 când a ajuns la 18 % (fraza mare e atunci sus, citită)
      var k = 0;
      if (viziune) {
        var V = viziune.getBoundingClientRect().top;
        var deLa = Math.min(0.8 * vh, V + y);
        k = clamp((deLa - V) / Math.max(1, deLa - 0.18 * vh), 0, 1);
      }
      stare.k = k;
      // se liniștesc: agitația scade (aceeași comandă le-ar strânge în inel dacă ar merge până la capăt; aici se oprește la
      // jumătatea drumului, când nu se mai văd) și dispar; de aici încolo pagina nu mai are particule
      var p = 0.5 * k, dim = 1 - k;
      if (Math.abs(p - ultimP) > 0.001) { ultimP = p; window.PsifyWebGL.setProgress(p); }
      if (Math.abs(dim - ultimDim) > 0.001 || (dim === 0) !== (ultimDim === 0)) { ultimDim = dim; window.PsifyWebGL.setRing({ dim: dim, offsetPx: 0 }); }
      stare.p = p; stare.dim = dim;
    }

    // 3. fraza mare a manifestului: cuvintele se aprind pe rând
    var fraze = Array.prototype.slice.call(document.querySelectorAll('[data-psih-cuvinte]'));
    var lin = Array.prototype.slice.call(document.querySelectorAll('.psih-v-rv'));
    if (fraze.length) {
      fraze.forEach(function (fraza) {
        // fraza are propozițiile pe rândurile lor (.psih-v-rand): cuvintele se aprind în șir, de la un rând la altul
        var parti = Array.prototype.slice.call(fraza.querySelectorAll('.psih-v-rand'));
        if (!parti.length) parti = [fraza];
        var nr = 0;
        parti.forEach(function (parte) {
          var cuvinte = parte.textContent.trim().split(/\s+/);
          parte.textContent = '';
          cuvinte.forEach(function (c, i) {
            var s = document.createElement('span');
            s.className = 'psih-w';
            s.textContent = c;
            s.style.transitionDelay = (nr++ * 0.045).toFixed(3) + 's';
            parte.appendChild(s);
            if (i < cuvinte.length - 1) parte.appendChild(document.createTextNode(' '));
          });
        });
      });
      if (reduced || !('IntersectionObserver' in window)) {
        fraze.concat(lin).forEach(function (el) { el.classList.add('is-in'); });
      } else {
        if (viziune) viziune.classList.add('is-armat');         // de aici stilurile țin alineatele ascunse până apar
        var io = new IntersectionObserver(function (intrari) {
          intrari.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
          // fraza se aprinde când mijlocul ei a trecut de 82 % din fereastră: pe telefoanele înalte primul ei rând e în
          // primul ecran de la încărcare, iar aprinderea s-ar fi petrecut înainte s-o vadă cineva
        }, { threshold: 0.5, rootMargin: '0px 0px -18% 0px' });
        fraze.forEach(function (fraza) { io.observe(fraza); });
        // alineatele apar de cum intră în fereastră (blocul e înalt: jumătate din el nu încape mereu în fereastră)
        var ioLin = new IntersectionObserver(function (intrari) {
          intrari.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ioLin.unobserve(e.target); } });
        }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
        lin.forEach(function (el) { ioLin.observe(el); });
      }
    }

    window.requestAnimationFrame(cadru);
  })();

  /* ================================================================
     5. recenziile citite cu voce (src/voci3d.js)
     ================================================================ */
  (function voci() {
    var sectiune = document.querySelector('[data-psih-v3d]');
    if (!sectiune) return;
    var panou = sectiune.querySelector('.psih-v3d-panou');
    var cadru = sectiune.querySelector('.psih-v3d-cadru');
    var scena = sectiune.querySelector('.psih-v3d-scena');
    var bara = sectiune.querySelector('.psih-v3d-bara');
    var antet = sectiune.querySelector('.psi-voices-header');
    var originale = Array.prototype.slice.call(scena.querySelectorAll('.psih-v3d-voce'));
    if (!cadru || !originale.length) return;
    if (!(window.CSS && CSS.supports && CSS.supports('transform-style', 'preserve-3d'))) return;

    var iesirePatrat = function (t) { return 1 - (1 - t) * (1 - t); };                                // power1.out
    var cubInOut = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };  // power3.inOut
    var cubOut = function (t) { return 1 - Math.pow(1 - t, 3); };                                      // power3.out
    var redus = reduced;
    var cuMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // ---------- stiva ----------
    // cu mai puțin de cinci recenzii, lista se repetă, ca stiva să aibă mereu ce arăta în spate
    var MINIM = 5;
    var lista = originale.slice();
    while (lista.length < MINIM) {
      originale.forEach(function (o) {
        var c = o.cloneNode(true);
        c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-clona', '');
        scena.appendChild(c); lista.push(c);
      });
    }
    var N = lista.length;
    var carduri = lista.map(function (el) {
      var cuv = Array.prototype.slice.call(el.querySelectorAll('.psih-v3d-w'));
      var timpi; try { timpi = JSON.parse(el.getAttribute('data-timpi') || '[]'); } catch (e) { timpi = []; }
      var durata = parseFloat(el.getAttribute('data-durata')) || Math.max(8, cuv.length * 0.4);
      // fără timpi: cuvintele împărțite egal pe durată, ca în referință
      if (timpi.length !== cuv.length) timpi = cuv.map(function (_, i) { return i * durata / cuv.length; });
      return {
        el: el, loc: el.querySelector('.psih-v3d-loc'), mouse: el.querySelector('.psih-v3d-mouse'), par: el.querySelector('.psih-v3d-paralaxa'),
        cuv: cuv, timpi: timpi, durata: durata, sunet: el.getAttribute('data-sunet'),   // data-sunet = adresa fișierului
        alfa: cuv.map(function () { return 0.4; }), faza: 'stins', tStinge: 0, deLa: null,
        st: { a: 0, x: 0, y: 0, z: 0, b: 0 }, tw: null
      };
    });

    var W = 0, s = 1, mobil = false, yFata = 0, xUrm = 0, yUrm = 0, yTrei = 0, aTrei = 0.2, u = 0, inTrecere = false;
    var litera = 1;                                             // cât s-a micșorat litera ca recenziile să încapă într-un ecran
    var s0 = 0.92, zoom = 1;                                    // banda la repaus față de fereastră; mărimea ei de acum
    // Cât se vede de mare o poveste la z −500 și la z −1000. Perspectiva de 1200 px e pusă de două ori, pe scenă și pe
    // fiecare poveste (ca în referință), iar două perspective la rând fac cât una de 600 px: 600/1100 și 600/1600.
    var F1 = 600 / 1100, F2 = 600 / 1600;
    // Secțiunea ține un singur ecran: scena e ce rămâne sub titlu. Locurile din referință se păstrează cât încap; unde
    // scena e mai scundă, poveștile din spate se opresc la marginea ei de sus (nu urcă peste titlu), iar cea din față nu
    // coboară peste butoane.
    function masoara() {
      W = window.innerWidth;
      mobil = W < 768;
      s = mobil ? clamp(W / 375, 1, 1.25) : clamp(W / 1440, 0.78, 1.2);
      cadru.style.setProperty('--v3d-s', s.toFixed(4));
      var col = sectiune.querySelector('.psi-container');
      s0 = clamp((col ? col.offsetWidth : W * 0.92) / W, 0.86, 0.94);
      var lat = carduri[0].el.offsetWidth;
      var catInalt = function () { var h = 0; carduri.forEach(function (c) { h = Math.max(h, c.el.offsetHeight); }); return h; };
      // locul butoanelor de jos; povestea din față le ocolește doar unde ajunge deasupra lor
      var jos = bara ? bara.offsetHeight + (parseFloat(window.getComputedStyle(bara).bottom) || 0) + 14 : 0;
      var Ws = scena.clientWidth, st = Ws / 2 + (mobil ? 0 : -190 * s) - lat / 2, dr = st + lat;
      var peste = !!bara && (st < bara.offsetLeft + (btnSunet ? btnSunet.offsetWidth : 0) + 16 || dr > bara.offsetLeft + bara.offsetWidth - (btnUrm ? btnUrm.offsetWidth : 0) - 16);
      var rezerva = peste ? jos + 20 : 48;
      // un singur ecran și cu recenzii lungi: dacă cea mai înaltă poveste nu încape în ce rămâne sub titlu, litera scade
      // (cel mult până la 80 %); abia dacă nici așa nu încape, secțiunea crește peste un ecran
      cadru.style.minHeight = '';
      cadru.style.setProperty('--v3d-f', '1');
      var loc = scena.clientHeight, inalt = catInalt(), f = 1;
      for (var pas = 0; pas < 4 && inalt + rezerva > loc && f > 0.8; pas++) {
        f = Math.max(0.8, f * Math.sqrt(Math.max(0.5, (loc - rezerva) / inalt)) - 0.005);
        cadru.style.setProperty('--v3d-f', f.toFixed(3));
        inalt = catInalt();
      }
      litera = f;
      cadru.style.minHeight = Math.ceil(inalt + rezerva) + 'px';
      var Hs = scena.clientHeight;
      var josMax = peste ? (Hs - jos) - (Hs / 2 + inalt / 2) : (Hs / 2 - inalt / 2) - 10;
      var susMin = Math.min(josMax, -(Hs / 2 - inalt / 2) + 10);
      yFata = clamp(mobil ? 100 * s : 0, susMin, josMax);
      // a treia, sus în fund: până la marginea de sus a scenei
      yTrei = Math.max((mobil ? -650 : -450) * s, (6 + inalt * F2 / 2 - Hs / 2) / F2);
      aTrei = 0.2;
      if (mobil) {
        // următoarea se ivește sus-dreapta, deasupra celei din față. Unde nu e loc pe înălțime (ar sta peste textul celei
        // din față), din ea rămâne doar o margine în dreapta ferestrei, urcată pe lângă titlu (titlul e la stânga)
        var susFata = Hs / 2 + yFata - inalt / 2, h1 = inalt * F1;
        var faraPeste = susFata - 4 - h1 / 2 - Hs / 2, inScena = 4 + h1 / 2 - Hs / 2;
        var yVazut = Math.min(-200 * s * F1, faraPeste);
        if (yVazut >= inScena) xUrm = 190 * s;
        else {
          yVazut = Math.max(faraPeste, inScena - Math.max(0, (antet ? antet.offsetHeight : 0) - 12));
          // dacă nici pe lângă titlu nu încape deasupra, marginea ei se retrage dincolo de textul celei din față
          var stanga = (Hs / 2 + yVazut + h1 / 2) - susFata > 2 ? Math.max(Ws - 56 * s, Ws / 2 + lat / 2 + 4) : Ws - 56 * s;
          xUrm = (stanga + lat * F1 / 2 - Ws / 2) / F1;
        }
        yUrm = yVazut / F1;
      } else {
        xUrm = 530 * s; yUrm = yFata;
        // pe ferestre joase a treia nu mai încape deasupra următoarei: se stinge, ca să nu stea două texte neclare unul peste altul
        var pesteUrm = (yTrei * F2 + inalt * F2 / 2) - (yUrm * F1 - inalt * F1 / 2);
        aTrei = 0.2 * clamp(1 - pesteUrm / (30 * s), 0, 1);
      }
    }
    function tinta(rol) {
      if (mobil) {
        if (rol === 0) return { a: 1, x: 0, y: yFata, z: 0, b: 0 };
        if (rol === N - 1) return { a: 0, x: -600 * s, y: 0, z: 500 * s, b: 5 * s };
        if (rol === 1) return { a: 0.5, x: xUrm, y: yUrm, z: -500 * s, b: 2 * s };
        if (rol === 2) return { a: aTrei, x: 510 * s, y: yTrei, z: -1000 * s, b: 5 * s };
        return { a: 0, x: 1000 * s, y: -1500 * s, z: -1500 * s, b: 5 * s };
      }
      if (rol === 0) return { a: 1, x: -190 * s, y: yFata, z: 0, b: 0 };
      if (rol === N - 1) return { a: 0, x: -600 * s, y: yFata, z: 500 * s, b: 5 * s };
      if (rol === 1) return { a: 0.5, x: xUrm, y: yUrm, z: -500 * s, b: 2 * s };
      if (rol === 2) return { a: aTrei, x: 450 * s, y: yTrei, z: -1000 * s, b: 5 * s };
      return { a: 0, x: 100 * s, y: -1000 * s, z: -1500 * s, b: 5 * s };
    }
    function pune(c) {
      var st = c.st;
      c.loc.style.transform = 'translate3d(' + st.x.toFixed(2) + 'px,' + st.y.toFixed(2) + 'px,' + st.z.toFixed(2) + 'px)';
      c.loc.style.opacity = st.a.toFixed(3);
      c.loc.style.filter = st.b > 0.02 ? 'blur(' + st.b.toFixed(2) + 'px)' : 'none';
      c.loc.style.visibility = st.a <= 0.001 ? 'hidden' : 'visible';
    }
    function asaza(durata) {
      var acum = performance.now();
      if (redus) durata = 0;
      carduri.forEach(function (c, k) {
        var rol = (k - u + N) % N, la = tinta(rol);
        c.el.setAttribute('data-rol', rol === 0 ? 'fata' : rol === 1 ? 'urmatoarea' : rol === 2 ? 'a-treia' : rol === N - 1 ? 'dusa' : 'ascunsa');
        if (!c.el.hasAttribute('data-clona')) { if (rol === 0) c.el.removeAttribute('aria-hidden'); else c.el.setAttribute('aria-hidden', 'true'); }
        var ascuns = rol > 2 && rol !== N - 1;
        if (ascuns || !durata) {
          c.tw = null; c.st = la; pune(c);
          if (rol === 0) inTrecere = false;
        } else {
          c.tw = { de: { a: c.st.a, x: c.st.x, y: c.st.y, z: c.st.z, b: c.st.b }, la: la, t0: acum, dur: durata * 1000, fata: rol === 0 };
        }
      });
    }
    function miscaCarduri(acum) {
      carduri.forEach(function (c) {
        var tw = c.tw; if (!tw) return;
        var q = clamp((acum - tw.t0) / tw.dur, 0, 1), e = cubInOut(q), d = tw.de, l = tw.la;
        c.st = { a: d.a + (l.a - d.a) * e, x: d.x + (l.x - d.x) * e, y: d.y + (l.y - d.y) * e, z: d.z + (l.z - d.z) * e, b: d.b + (l.b - d.b) * e };
        pune(c);
        if (q >= 1) { c.tw = null; if (tw.fata) inTrecere = false; }
      });
    }

    // ---------- sunetul ----------
    // Fișierele (public/media/home/voci, cu amprentă în adresă) se cer abia când secțiunea se apropie de fereastră
    // (observatorul de la sfârșit) sau la primul gest pe ea, niciodată la deschiderea paginii.
    var AC = window.AudioContext || window.webkitAudioContext;
    var adrese = {};
    carduri.forEach(function (c) { if (c.sunet) adrese[c.sunet] = true; });
    var trecereUrl = sectiune.getAttribute('data-trecere') || '';
    if (trecereUrl) adrese[trecereUrl] = true;
    var ctx = null, master = null, impuls = null, tampoane = {}, incarcat = false, deblocat = false;
    var CHEIE = 'psih-voci-sunet';
    var mut = false; try { mut = localStorage.getItem(CHEIE) === 'oprit'; } catch (e) {}
    var VOCE = 1, GRUP = 0.9, VUIET = 0.4;                      // volumele din referință (vocea 1, grupul 0,9, vuietul 0,4)
    var reiaLaDeblocare = false;
    var stareSunet = { deblocat: false, mut: mut, canta: 0, vuiete: 0, cerute: 0, gata: 0 };

    function context() {
      if (ctx || !AC) return ctx;
      try { ctx = new AC(); } catch (e) { ctx = null; AC = null; return null; }
      master = ctx.createGain(); master.gain.value = mut ? 0 : GRUP; master.connect(ctx.destination);
      // ecoul: zgomot care se stinge (1 s, exponent 3), ca în referință
      var n = Math.floor(ctx.sampleRate * 1), b = ctx.createBuffer(2, n, ctx.sampleRate);
      for (var canal = 0; canal < 2; canal++) { var dd = b.getChannelData(canal); for (var i = 0; i < n; i++) dd[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 3); }
      impuls = b;
      ctx.onstatechange = stareNoua;
      stareNoua();
      return ctx;
    }
    function incarca() {
      if (incarcat || !window.fetch || !context()) return;
      incarcat = true;
      Object.keys(adrese).forEach(function (url) {
        stareSunet.cerute++;
        var gata = function (buf) { tampoane[url] = buf; stareSunet.gata++; laDeblocare(); };
        window.fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.arrayBuffer(); })
          .then(function (oct) {
            try { var pr = ctx.decodeAudioData(oct, gata, function () {}); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
          })
          .catch(function () {});
      });
    }
    function stareNoua() {
      var era = deblocat;
      deblocat = !!ctx && ctx.state === 'running';
      stareSunet.deblocat = deblocat;
      // sunetul oprit de sistem în mijlocul unei recenzii (un apel, fereastra trimisă în spate): vocea ei se lasă; la
      // întoarcere intră din nou la secunda la care au ajuns cuvintele, nu de unde a înghețat
      if (!deblocat && era && citire && citire.sunet) { try { citire.sunet.src.stop(); } catch (e) {} citire.sunet = null; }
      if (deblocat && !era) laDeblocare();
      arataSunet();
    }
    // vocea intră în recenzia care se citește deja fără sunet (la secunda la care a ajuns) sau, dacă omul a cerut sunetul, o reia
    function laDeblocare() {
      if (!deblocat) return;
      if (reiaLaDeblocare) { reiaLaDeblocare = false; reia(); return; }
      if (citire && !citire.sunet) canta(citire, (performance.now() - citire.t0) / 1000);
    }
    function gest() {
      if (!AC) return;
      context();
      if (ctx && ctx.state !== 'running') { try { var pr = ctx.resume(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} }
    }
    // orice gest pe pagină (și cel de pe bannerul de cookie-uri) deblochează sunetul, ca ecranul „Click to enter” din
    // referință; fișierele nu se cer însă decât când secțiunea se apropie (incarca)
    ['pointerup', 'touchend', 'click', 'keydown'].forEach(function (ev) { window.addEventListener(ev, gest, { capture: true, passive: true }); });

    function drum() { return Math.sin(p * Math.PI); }
    function canta(cit, deLaSec) {
      if (!ctx || !deblocat || cit.sunet) return;
      var buf = tampoane[cit.c.sunet];
      if (!buf || deLaSec >= buf.duration - 0.05) return;
      var O = drum(), mix = 0.6 * Math.abs(2 * p - 1);
      var src = ctx.createBufferSource(); src.buffer = buf;
      var g = ctx.createGain(); g.gain.value = VOCE * O;
      var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 200 + O * 9800; lp.Q.value = 0.01;
      var uscat = ctx.createGain(), ud = ctx.createGain(), conv = ctx.createConvolver(); conv.buffer = impuls;
      uscat.gain.value = mix <= 0.5 ? 1 : 1 - 2 * (mix - 0.5); ud.gain.value = mix >= 0.5 ? 1 : 1 - 2 * (0.5 - mix);
      src.connect(g); g.connect(lp); lp.connect(uscat); uscat.connect(master); lp.connect(conv); conv.connect(ud); ud.connect(master);
      var sn = { src: src, g: g, lp: lp, uscat: uscat, ud: ud, conv: conv };
      src.onended = function () { try { ud.disconnect(); uscat.disconnect(); conv.disconnect(); lp.disconnect(); g.disconnect(); } catch (e) {} stareSunet.canta = Math.max(0, stareSunet.canta - 1); };
      src.start(0, Math.max(0, deLaSec));
      stareSunet.canta++;
      cit.sunet = sn;
    }
    function opresteVocea(cit, inSec) {
      var sn = cit && cit.sunet; if (!sn) return;
      cit.sunet = null;
      var t = ctx.currentTime;
      try {
        sn.g.gain.cancelScheduledValues(t); sn.g.gain.setValueAtTime(sn.g.gain.value, t);
        sn.g.gain.linearRampToValueAtTime(0, t + Math.max(0.03, inSec));
        sn.src.stop(t + Math.max(0.03, inSec) + 0.05);
      } catch (e) {}
    }
    function vuiet() {
      if (!ctx || !deblocat || !trecereUrl || !tampoane[trecereUrl]) return;
      var src = ctx.createBufferSource(); src.buffer = tampoane[trecereUrl];
      var g = ctx.createGain(); g.gain.value = VUIET;
      src.connect(g); g.connect(master);
      src.onended = function () { try { g.disconnect(); } catch (e) {} };
      src.start();
      stareSunet.vuiete++;
    }
    function sunetCadru() {
      var sn = citire && citire.sunet; if (!sn) return;
      var t = ctx.currentTime, O = drum(), mix = 0.6 * Math.abs(2 * p - 1);
      sn.g.gain.setTargetAtTime(VOCE * O, t, 0.04);
      sn.lp.frequency.setTargetAtTime(200 + O * 9800, t, 0.04);
      sn.uscat.gain.setTargetAtTime(mix <= 0.5 ? 1 : 1 - 2 * (mix - 0.5), t, 0.04);
      sn.ud.gain.setTargetAtTime(mix >= 0.5 ? 1 : 1 - 2 * (0.5 - mix), t, 0.04);
    }

    // butonul de sunet
    var btnSunet = cadru.querySelector('.psih-v3d-sunet');
    var etSunet = btnSunet && btnSunet.querySelector('.psih-v3d-sunet-text');
    function arataSunet() {
      if (!btnSunet) return;
      if (!AC) { btnSunet.hidden = true; return; }
      var aude = deblocat && !mut;
      btnSunet.classList.toggle('is-pornit', aude);
      btnSunet.setAttribute('aria-pressed', aude ? 'true' : 'false');
      if (etSunet) etSunet.textContent = aude ? btnSunet.getAttribute('data-opreste') : btnSunet.getAttribute('data-porneste');
      cadru.classList.toggle('are-sunet', aude);
    }
    function tineMinte() { try { if (mut) localStorage.setItem(CHEIE, 'oprit'); else localStorage.removeItem(CHEIE); } catch (e) {} stareSunet.mut = mut; }
    function volumGrup(v) {
      if (!master) return;
      var t = ctx.currentTime;
      master.gain.cancelScheduledValues(t); master.gain.setValueAtTime(master.gain.value, t); master.gain.linearRampToValueAtTime(v, t + 0.5);
    }
    if (btnSunet) btnSunet.addEventListener('click', function () {
      if (!AC) return;
      incarca();
      if (!deblocat) {                       // primul gest: pornește sunetul și reia recenzia din față, cu voce
        mut = false; tineMinte(); volumGrup(GRUP);
        reiaLaDeblocare = true; gest();
        if (deblocat) laDeblocare();
      } else {
        mut = !mut; tineMinte(); volumGrup(mut ? 0 : GRUP);
      }
      arataSunet();
    });

    // ---------- mersul ----------
    var p = 0, inFereastra = false, pornit = false, asteptare = 0, citire = null;
    function incepe() {
      var c = carduri[u];
      window.clearTimeout(asteptare);
      asteptare = window.setTimeout(function () {
        asteptare = 0;
        citire = { c: c, t0: performance.now(), sunet: null, gata: false };
        c.faza = 'citeste';
        c.el.classList.remove('is-citit-indata'); c.el.classList.add('is-citit');
        canta(citire, 0);
        inel.mod = 'merge'; inel.t0 = citire.t0; inel.dur = Math.max(0.5, c.durata - 0.2) * 1000; inel.a = 0; inel.b = 0;
      }, 1000);
    }
    function stinge(c) {
      c.deLa = c.alfa.slice(); c.tStinge = performance.now(); c.faza = 'stinge';
    }
    function avanseaza() {
      if (inTrecere) return;
      window.clearTimeout(asteptare); asteptare = 0;
      inTrecere = true;
      vuiet();
      var c = carduri[u];
      stinge(c); c.el.classList.remove('is-citit', 'is-citit-indata');
      if (citire) { opresteVocea(citire, 2); citire = null; }
      u = (u + 1) % N;
      incepe();
      asaza(1.5);
    }
    // recenzia din față, de la capăt (la întoarcerea în fereastră sau când omul pornește sunetul)
    function reia() {
      window.clearTimeout(asteptare); asteptare = 0;
      if (citire) { opresteVocea(citire, 0.3); citire = null; }
      var c = carduri[u];
      if (c.faza !== 'stins') stinge(c);
      if (inFereastra) incepe();
    }
    function intra() {
      incarca();
      if (!pornit) { pornit = true; incepe(); } else reia();
    }
    function iese() {
      window.clearTimeout(asteptare); asteptare = 0;
      if (citire) { opresteVocea(citire, 0); citire = null; }
      inel.mod = 'reset'; inel.t0 = performance.now(); inel.de = inel.b; inel.a = 0;
      var c = carduri[u];
      c.faza = 'plin'; c.deLa = null;
      for (var i = 0; i < c.cuv.length; i++) { c.alfa[i] = 1; c.cuv[i].style.opacity = '1'; }
    }
    function cuvinteCadru(acum) {
      carduri.forEach(function (c) {
        if (c.faza !== 'citeste' && c.faza !== 'stinge') return;
        var i, v, n = c.cuv.length;
        if (c.faza === 'citeste') {
          var t = citire && citire.c === c ? (acum - citire.t0) / 1000 : 0;
          for (i = 0; i < n; i++) {
            v = 0.4 + 0.6 * iesirePatrat(clamp((t - c.timpi[i]) / 3, 0, 1));
            if (Math.abs(v - c.alfa[i]) > 0.004) { c.alfa[i] = v; c.cuv[i].style.opacity = v.toFixed(3); }
          }
        } else {
          var q = iesirePatrat(clamp((acum - c.tStinge) / 500, 0, 1));
          for (i = 0; i < n; i++) {
            v = c.deLa[i] + (0.4 - c.deLa[i]) * q;
            if (Math.abs(v - c.alfa[i]) > 0.004 || q >= 1) { c.alfa[i] = v; c.cuv[i].style.opacity = v.toFixed(3); }
          }
          if (q >= 1) { c.faza = 'stins'; c.deLa = null; }
        }
      });
    }

    // clicul pe scenă: următoarea. Cu sunetul încă blocat de browser, primul clic îl pornește și reia recenzia din față.
    var blocatLaApasare = false;
    scena.addEventListener('pointerdown', function () { blocatLaApasare = !!AC && !deblocat && !mut; });
    scena.addEventListener('click', function () {
      if (blocatLaApasare) {
        blocatLaApasare = false;
        incarca(); reiaLaDeblocare = true; gest();
        if (deblocat) laDeblocare();
        return;
      }
      avanseaza();
    });
    var btnUrm = cadru.querySelector('.psih-v3d-urm');
    if (btnUrm) btnUrm.addEventListener('click', function () { incarca(); avanseaza(); });

    // ---------- mouse-ul ----------
    var mx = 0, my = 0, areMouse = false;
    var d = [0, 0, 0, 0], dt = [0, 0, 0, 0], ultimaInclinare = '';
    if (cuMouse) window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!areMouse) { areMouse = true; curS = null; curI = null; }
      if (redus) return;
      var vw = window.innerWidth, vh = window.innerHeight, R = vw / 1440 * 10;
      dt = [(mx / vw * 2 - 1) * R, (my / vh * 2 - 1) * R, my / vh * 20 - 10, mx / vw * 20 - 10];
    }, { passive: true });
    function inclinaCadru(pasi) {
      if (!cuMouse || redus) return;
      var k = 1 - Math.pow(0.95, pasi);
      for (var i = 0; i < 4; i++) d[i] += (dt[i] - d[i]) * k;
      var semn = d[0].toFixed(2) + d[1].toFixed(2) + d[2].toFixed(3) + d[3].toFixed(3);
      if (semn === ultimaInclinare) return;
      ultimaInclinare = semn;
      var rot = 'rotateX(' + (-d[2]).toFixed(3) + 'deg) rotateY(' + d[3].toFixed(3) + 'deg)', mut2 = 'translate(' + d[0].toFixed(2) + 'px,' + d[1].toFixed(2) + 'px)';
      carduri.forEach(function (c) { c.el.style.transform = rot; c.mouse.style.transform = mut2; });
    }

    // ---------- cursorul scenei și inelul ----------
    var cursor = cadru.querySelector('.psih-v3d-cursor');
    var curInel = cursor && cursor.querySelector('.psih-v3d-cursor-inel'), curSag = cursor && cursor.querySelector('.psih-v3d-cursor-sageata');
    var arce = Array.prototype.slice.call(cadru.querySelectorAll('.psih-v3d-arc'));
    var inel = { mod: 'gol', t0: 0, dur: 1, a: 0, b: 0, de: 0 }, ultimArc = '';
    var curS = null, curI = null, peScena = false;
    function peste(da) {
      if (da === peScena) return;
      peScena = da;
      cadru.classList.toggle('are-cursor', da);
      document.body.classList.toggle('psih-v3d-peste', da);
      if (page !== document.body) page.classList.toggle('psih-v3d-peste', da);
    }
    if (cuMouse && cursor) {
      scena.addEventListener('mouseenter', function () { peste(true); });
      scena.addEventListener('mousemove', function () { peste(true); }, { passive: true });
      scena.addEventListener('mouseleave', function () { peste(false); });
    }
    function cursorCadru(acum, pasi) {
      // inelul: se desenează cât ține înregistrarea (fără ultimele 0,2 s), apoi se strânge spre capăt
      if (inel.mod === 'merge') {
        inel.b = clamp((acum - inel.t0) / inel.dur, 0, 1); inel.a = 0;
        if (inel.b >= 1) { inel.mod = 'strange'; inel.t0 = acum; }
      } else if (inel.mod === 'strange') {
        inel.a = cubOut(clamp((acum - inel.t0) / 500, 0, 1)); inel.b = 1;
        if (inel.a >= 1) inel.mod = 'gol';
      } else if (inel.mod === 'reset') {
        var q = cubOut(clamp((acum - inel.t0) / 500, 0, 1));
        inel.b = inel.de * (1 - q); inel.a = 0;
        if (q >= 1) inel.mod = 'gol';
      }
      var lung = Math.max(0, inel.b - inel.a) * 100, semn = lung.toFixed(2) + '/' + (inel.a * 100).toFixed(2);
      if (semn !== ultimArc) {
        ultimArc = semn;
        arce.forEach(function (arc) { arc.style.strokeDasharray = lung.toFixed(2) + ' 100'; arc.style.strokeDashoffset = (-inel.a * 100).toFixed(2); });
      }
      if (!cuMouse || !cursor || !areMouse) return;
      var r = cadru.getBoundingClientRect(), x = (mx - r.left) / zoom, y = (my - r.top) / zoom;   // banda poate fi micșorată
      if (!curS) { curS = [x, y]; curI = [x, y]; }
      var kS = 1 - Math.pow(0.7, pasi), kI = 1 - Math.pow(0.9, pasi);
      curS[0] += (x - curS[0]) * kS; curS[1] += (y - curS[1]) * kS;
      curI[0] += (x - curI[0]) * kI; curI[1] += (y - curI[1]) * kI;
      curSag.style.transform = 'translate3d(' + curS[0].toFixed(1) + 'px,' + curS[1].toFixed(1) + 'px,0)';
      curInel.style.transform = 'translate3d(' + curI[0].toFixed(1) + 'px,' + curI[1].toFixed(1) + 'px,0)';
    }

    // ---------- cadrul ----------
    var raf = 0, ultim = 0, ultimaParalaxa = null, ultimZoom = null;
    var faraZoom = sectiune.getAttribute('data-zoom') === 'nu';
    var neted = function (t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
    function cadruNou(acum) {
      raf = window.requestAnimationFrame(cadruNou);
      var pasi = clamp((acum - ultim) / (1000 / 60), 0.2, 6); ultim = acum;
      // drumul secțiunii prin fereastră: 0 când îi apare marginea de sus jos în fereastră, 0,5 când o umple, 1 când a ieșit
      var r = sectiune.getBoundingClientRect(), vh = window.innerHeight;
      p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      // zoomul (doar fără data-zoom="nu"): banda crește de la lățimea coloanei până umple fereastra și se strânge când pleacă
      var f = redus ? 1 : neted((p <= 0.5 ? p : 1 - p) / 0.44);
      var z = s0 + (1 - s0) * f;
      if (faraZoom) { zoom = 1; ultimZoom = 1; }               // banda stă pe loc, cu marginile și colțurile din stiluri
      else if (panou && Math.abs(z - zoom) > 0.0004 || ultimZoom === null) {
        zoom = z; ultimZoom = z;
        if (panou) { panou.style.transform = z > 0.9996 ? 'none' : 'scale(' + z.toFixed(4) + ')'; panou.style.borderRadius = (32 * (1 - f) / z).toFixed(1) + 'px'; }
      }
      // se citește de când scena (partea de sub titlu) intră în fereastră până iese
      var rs = scena.getBoundingClientRect();
      var inAcum = rs.top < vh && rs.bottom > 0 && !document.hidden;
      if (inAcum !== inFereastra) { inFereastra = inAcum; if (inAcum) intra(); else iese(); }
      // textul urcă mai repede decât pagina
      var py = redus ? 0 : (1 - 2 * p) * (mobil ? 100 : 250) * s;
      if (ultimaParalaxa === null || Math.abs(py - ultimaParalaxa) > 0.05) {
        ultimaParalaxa = py;
        var tr = 'translate3d(0,' + py.toFixed(2) + 'px,0)';
        carduri.forEach(function (c) { c.par.style.transform = tr; });
      }
      inclinaCadru(pasi);
      miscaCarduri(acum);
      // vocea a terminat: următoarea
      if (citire && !citire.gata && (acum - citire.t0) / 1000 >= citire.c.durata) { citire.gata = true; avanseaza(); }
      cuvinteCadru(acum);
      sunetCadru();
      cursorCadru(acum, pasi);
      stare.p = p; stare.u = u; stare.inFereastra = inFereastra; stare.inTrecere = inTrecere; stare.citeste = !!citire; stare.t = citire ? (acum - citire.t0) / 1000 : 0;
    }
    function porneste() { if (!raf) { ultim = performance.now(); raf = window.requestAnimationFrame(cadruNou); } }
    function opreste() {
      if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
      if (inFereastra) { inFereastra = false; iese(); }
      peste(false);
    }

    // pentru verificări
    var stare = { p: 0, u: 0, n: N, inFereastra: false, inTrecere: false, citeste: false, t: 0, sunet: stareSunet };
    window.PsihVoci3d = {
      stare: stare,
      carduri: function () { return carduri.map(function (c) { return { rol: c.el.getAttribute('data-rol'), st: c.st, faza: c.faza, durata: c.durata, sunet: c.sunet }; }); },
      scara: function () { return { s: s, mobil: mobil, yFata: yFata, xUrm: xUrm, yUrm: yUrm, yTrei: yTrei, aTrei: aTrei, s0: s0, zoom: zoom, litera: litera }; }
    };

    sectiune.classList.add('is-armat');
    masoara();
    carduri[0].el.classList.add('is-citit', 'is-citit-indata');      // rândul cu numele al primei povești e acolo de la început
    asaza(0);
    arataSunet();
    var laRedimensionare = 0;
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(laRedimensionare);
      laRedimensionare = window.requestAnimationFrame(function () { masoara(); asaza(0); });
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden && inFereastra) { inFereastra = false; iese(); } });
    // cadrele merg doar cât secțiunea e aproape de fereastră (60 % de ea); tot atunci se cer fișierele de sunet
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (intrari) {
        intrari.forEach(function (e) { if (e.isIntersecting) { incarca(); porneste(); } else opreste(); });
      }, { rootMargin: '60% 0px 60% 0px' }).observe(sectiune);
    } else { incarca(); porneste(); }
    // literele titlurilor se încarcă după primul desen: înălțimile poveștilor se măsoară din nou
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { masoara(); asaza(0); });
  })();
})();
